import { styled } from "@mui/material";
import { drawerMiniWidth, drawerWidth, rightDrawerWidth } from "assets/jss/styles";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.activeColor,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSize,
  position: "relative",
  top: "0",
  height: "100vh",
  "&:after": {
    display: "table",
    clear: "both",
    content: '" "'
  }
}));

export const MainPanel = styled("div", {
  shouldForwardProp: prop => prop !== "miniActive" && prop !== "mobileOpen"
})(({ theme, miniActive, mobileOpen }) => {
  let mediaQueryWidth = `calc(100% - ${drawerWidth}px)`;
  if (miniActive) mediaQueryWidth = `calc(100% - ${drawerMiniWidth}px)`;
  if (mobileOpen && !miniActive) mediaQueryWidth = `calc(100% - ${drawerWidth + rightDrawerWidth}px)`;
  if (mobileOpen && miniActive) mediaQueryWidth = `calc(100% - ${drawerMiniWidth + rightDrawerWidth}px)`;

  return {
    [theme.breakpoints.up("md")]: {
      width: mediaQueryWidth,
      marginRight: mobileOpen ? rightDrawerWidth : "0"
    },
    overflow: "auto",
    overflowX: "hidden",
    position: "relative",
    float: "right",
    maxHeight: "100%",
    height: "100%",
    width: "100%",
    overflowScrolling: "touch"
  };
});

export const StickySideButtonsContainer = styled("div")(() => ({
  position: "sticky",
  top: 0,
  "@media (max-width: 480px)": {
    position: "inherit",
    zIndex: 1030
  }
}));
